import {z} from 'zod';

/**
 * Schema for POST /create request body
 */
export const createPromptRequestSchema = z.object({
  useCaseType: z.string().min(1).max(255),
  userPrompt: z.string().min(1),
  systemPrompt: z.string().min(1),
});
